var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerRadar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 251,
    viewBox: "0 0 234 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_765_7945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 234,
    height: 235
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234 117L117 0L-0.000491052 117L117 234.001L234 117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_765_7945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.996 224.92C176.596 224.92 224.912 176.604 224.912 117.004C224.912 57.4035 176.596 9.08789 116.996 9.08789C57.3957 9.08789 9.08008 57.4035 9.08008 117.004C9.08008 176.604 57.3957 224.92 116.996 224.92Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.996 202.947C164.461 202.947 202.939 164.469 202.939 117.004C202.939 69.5391 164.461 31.061 116.996 31.061C69.5308 31.061 31.0527 69.5391 31.0527 117.004C31.0527 164.469 69.5308 202.947 116.996 202.947Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.996 180.974C152.325 180.974 180.966 152.333 180.966 117.003C180.966 81.6736 152.325 53.0332 116.996 53.0332C81.6659 53.0332 53.0254 81.6736 53.0254 117.003C53.0254 152.333 81.6659 180.974 116.996 180.974Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.727 146.698C130.31 163.115 103.719 163.115 87.3026 146.698C70.8861 130.282 70.8861 103.691 87.3026 87.274C103.719 70.8575 130.31 70.8575 146.727 87.274C163.143 103.691 163.143 130.282 146.727 146.698Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.176 131.183C123.347 139.013 110.647 139.013 102.817 131.183C94.988 123.354 94.988 110.654 102.817 102.824C110.647 94.9948 123.347 94.9948 131.176 102.824C139.006 110.654 139.006 123.354 131.176 131.183Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.76,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 248.183C15.8526 247.235 14.9902 246.467 13.9263 246.467C12.8625 246.467 12 247.235 12 248.183C12 249.132 12.8625 249.9 13.9263 249.9C14.9902 249.9 15.8526 249.132 15.8526 248.183Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 248.183C28.1534 249.128 27.2866 249.9 26.2271 249.9C25.1676 249.9 24.3008 249.128 24.3008 248.183C24.3008 247.239 25.1676 246.467 26.2271 246.467C27.2866 246.467 28.1534 247.239 28.1534 248.183Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4679 248.183C40.4679 247.235 39.6054 246.467 38.5416 246.467C37.4777 246.467 36.6152 247.235 36.6152 248.183C36.6152 249.132 37.4777 249.9 38.5416 249.9C39.6054 249.9 40.4679 249.132 40.4679 248.183Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7686 248.183C52.7686 249.128 51.9018 249.9 50.8423 249.9C49.7829 249.9 48.916 249.128 48.916 248.183C48.916 247.239 49.7829 246.467 50.8423 246.467C51.9018 246.467 52.7686 247.239 52.7686 248.183Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0831 248.183C65.0831 247.235 64.2207 246.467 63.1568 246.467C62.0929 246.467 61.2305 247.235 61.2305 248.183C61.2305 249.132 62.0929 249.9 63.1568 249.9C64.2207 249.9 65.0831 249.132 65.0831 248.183Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3839 248.183C77.3839 249.128 76.517 249.9 75.4576 249.9C74.3981 249.9 73.5313 249.128 73.5313 248.183C73.5313 247.239 74.3981 246.467 75.4576 246.467C76.517 246.467 77.3839 247.239 77.3839 248.183Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6846 248.183C89.6846 247.235 88.8222 246.467 87.7583 246.467C86.6945 246.467 85.832 247.235 85.832 248.183C85.832 249.132 86.6945 249.9 87.7583 249.9C88.8222 249.9 89.6846 249.132 89.6846 248.183Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.001 248.183C102.001 249.128 101.134 249.9 100.075 249.9C99.0153 249.9 98.1484 249.128 98.1484 248.183C98.1484 247.239 99.0153 246.467 100.075 246.467C101.134 246.467 102.001 247.239 102.001 248.183Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 237.822C15.8526 236.874 14.9902 236.106 13.9263 236.106C12.8625 236.106 12 236.874 12 237.822C12 238.77 12.8625 239.539 13.9263 239.539C14.9902 239.539 15.8526 238.77 15.8526 237.822Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 237.822C28.1534 238.767 27.2866 239.539 26.2271 239.539C25.1676 239.539 24.3008 238.767 24.3008 237.822C24.3008 236.878 25.1676 236.106 26.2271 236.106C27.2866 236.106 28.1534 236.878 28.1534 237.822Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4679 237.822C40.4679 236.874 39.6054 236.106 38.5416 236.106C37.4777 236.106 36.6152 236.874 36.6152 237.822C36.6152 238.77 37.4777 239.539 38.5416 239.539C39.6054 239.539 40.4679 238.77 40.4679 237.822Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7686 237.822C52.7686 238.767 51.9018 239.539 50.8423 239.539C49.7829 239.539 48.916 238.767 48.916 237.822C48.916 236.878 49.7829 236.106 50.8423 236.106C51.9018 236.106 52.7686 236.878 52.7686 237.822Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0831 237.822C65.0831 236.874 64.2207 236.106 63.1568 236.106C62.0929 236.106 61.2305 236.874 61.2305 237.822C61.2305 238.77 62.0929 239.539 63.1568 239.539C64.2207 239.539 65.0831 238.77 65.0831 237.822Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3839 237.822C77.3839 238.767 76.517 239.539 75.4576 239.539C74.3981 239.539 73.5313 238.767 73.5313 237.822C73.5313 236.878 74.3981 236.106 75.4576 236.106C76.517 236.106 77.3839 236.878 77.3839 237.822Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6846 237.822C89.6846 236.874 88.8222 236.106 87.7583 236.106C86.6945 236.106 85.832 236.874 85.832 237.822C85.832 238.77 86.6945 239.539 87.7583 239.539C88.8222 239.539 89.6846 238.77 89.6846 237.822Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 227.474C15.8526 228.418 14.9858 229.19 13.9263 229.19C12.8669 229.19 12 228.418 12 227.474C12 226.529 12.8669 225.757 13.9263 225.757C14.9858 225.757 15.8526 226.529 15.8526 227.474Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 227.474C28.1534 228.418 27.2866 229.19 26.2271 229.19C25.1676 229.19 24.3008 228.418 24.3008 227.474C24.3008 226.529 25.1676 225.757 26.2271 225.757C27.2866 225.757 28.1534 226.529 28.1534 227.474Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4542 227.474C40.4542 228.418 39.5873 229.19 38.5279 229.19C37.4684 229.19 36.6016 228.418 36.6016 227.474C36.6016 226.529 37.4684 225.757 38.5279 225.757C39.5873 225.757 40.4542 226.529 40.4542 227.474Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7686 227.474C52.7686 228.418 51.9018 229.19 50.8423 229.19C49.7829 229.19 48.916 228.418 48.916 227.474C48.916 226.529 49.7829 225.757 50.8423 225.757C51.9018 225.757 52.7686 226.529 52.7686 227.474Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0694 227.474C65.0694 228.418 64.2026 229.19 63.1431 229.19C62.0836 229.19 61.2168 228.418 61.2168 227.474C61.2168 226.529 62.0836 225.757 63.1431 225.757C64.2026 225.757 65.0694 226.529 65.0694 227.474Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3839 227.474C77.3839 228.418 76.517 229.19 75.4576 229.19C74.3981 229.19 73.5313 228.418 73.5313 227.474C73.5313 226.529 74.3981 225.757 75.4576 225.757C76.517 225.757 77.3839 226.529 77.3839 227.474Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 217.124C15.8526 216.176 14.9902 215.408 13.9263 215.408C12.8625 215.408 12 216.176 12 217.124C12 218.072 12.8625 218.841 13.9263 218.841C14.9902 218.841 15.8526 218.072 15.8526 217.124Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 217.124C28.1534 218.069 27.2866 218.841 26.2271 218.841C25.1676 218.841 24.3008 218.069 24.3008 217.124C24.3008 216.18 25.1676 215.408 26.2271 215.408C27.2866 215.408 28.1534 216.18 28.1534 217.124Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4679 217.124C40.4679 216.176 39.6054 215.408 38.5416 215.408C37.4777 215.408 36.6152 216.176 36.6152 217.124C36.6152 218.072 37.4777 218.841 38.5416 218.841C39.6054 218.841 40.4679 218.072 40.4679 217.124Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7686 217.124C52.7686 218.069 51.9018 218.841 50.8423 218.841C49.7829 218.841 48.916 218.069 48.916 217.124C48.916 216.18 49.7829 215.408 50.8423 215.408C51.9018 215.408 52.7686 216.18 52.7686 217.124Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0831 217.124C65.0831 216.176 64.2207 215.408 63.1568 215.408C62.0929 215.408 61.2305 216.176 61.2305 217.124C61.2305 218.072 62.0929 218.841 63.1568 218.841C64.2207 218.841 65.0831 218.072 65.0831 217.124Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 206.776C15.8526 205.827 14.9902 205.059 13.9263 205.059C12.8625 205.059 12 205.827 12 206.776C12 207.724 12.8625 208.492 13.9263 208.492C14.9902 208.492 15.8526 207.724 15.8526 206.776Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 206.776C28.1534 207.72 27.2866 208.492 26.2271 208.492C25.1676 208.492 24.3008 207.72 24.3008 206.776C24.3008 205.831 25.1676 205.059 26.2271 205.059C27.2866 205.059 28.1534 205.831 28.1534 206.776Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4679 206.776C40.4679 205.827 39.6054 205.059 38.5416 205.059C37.4777 205.059 36.6152 205.827 36.6152 206.776C36.6152 207.724 37.4777 208.492 38.5416 208.492C39.6054 208.492 40.4679 207.724 40.4679 206.776Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7686 206.776C52.7686 207.72 51.9018 208.492 50.8423 208.492C49.7829 208.492 48.916 207.72 48.916 206.776C48.916 205.831 49.7829 205.059 50.8423 205.059C51.9018 205.059 52.7686 205.831 52.7686 206.776Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 196.427C15.8526 195.479 14.9902 194.71 13.9263 194.71C12.8625 194.71 12 195.479 12 196.427C12 197.375 12.8625 198.143 13.9263 198.143C14.9902 198.143 15.8526 197.375 15.8526 196.427Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 196.427C28.1534 197.371 27.2866 198.143 26.2271 198.143C25.1676 198.143 24.3008 197.371 24.3008 196.427C24.3008 195.483 25.1676 194.71 26.2271 194.71C27.2866 194.71 28.1534 195.483 28.1534 196.427Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4679 196.427C40.4679 195.479 39.6054 194.71 38.5416 194.71C37.4777 194.71 36.6152 195.479 36.6152 196.427C36.6152 197.375 37.4777 198.143 38.5416 198.143C39.6054 198.143 40.4679 197.375 40.4679 196.427Z",
    stroke: "#61BED7",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 186.078C15.8526 185.13 14.9902 184.361 13.9263 184.361C12.8625 184.361 12 185.13 12 186.078C12 187.026 12.8625 187.794 13.9263 187.794C14.9902 187.794 15.8526 187.026 15.8526 186.078Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1534 186.078C28.1534 187.022 27.2866 187.794 26.2271 187.794C25.1676 187.794 24.3008 187.022 24.3008 186.078C24.3008 185.133 25.1676 184.361 26.2271 184.361C27.2866 184.361 28.1534 185.133 28.1534 186.078Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8526 175.717C15.8526 176.661 14.9858 177.433 13.9263 177.433C12.8669 177.433 12 176.661 12 175.717C12 174.772 12.8669 174 13.9263 174C14.9858 174 15.8526 174.772 15.8526 175.717Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerRadar);
export default __webpack_public_path__ + "static/media/banner-radar.e57abac1b419ff0fe6d7d5189b28424b.svg";
export { ForwardRef as ReactComponent };